import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAemConfig } from '@as-react/common-components';
import { BasketButtonError, NotifyMeError, PDPVersion } from '@as-react/common-types';
import { makeGetBasketValidationState } from '../redux/basket/selectors/BasketSelector';
import { productActions } from '../redux/product/actions/ProductActions';
import { makeGetNotifyMeError, makeGetProductSizes, makeGetSelectedColorId, makeGetSelectedSku, makeGetSizeCombinationNotExist, makeGetSizeRecommendation, } from '../redux/product/selectors/ProductSelector';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { ProductAddToBasketLocations } from '../enums/ActionEnums';
import { SizeSelectButtons } from '../components/product-detail/size-select-buttons/SizeSelectButtons';
import { isOneSizeProduct, isOnlyOneSizeProduct } from '@as-react/common-utils';
import { useProductDetailContext } from './product/ProductDetailV2Container';
const SizeSelectContainerV2 = ({ quantity }) => {
    const { oneSizeProductCode } = useAemConfig();
    const [addToBasketOnSizeSelect, setAddToBasketOnSizeSelect] = useState(false);
    const { selectedAdditionalProducts } = useProductDetailContext();
    const dispatch = useDispatch();
    const basketValidationState = useSelector(makeGetBasketValidationState());
    const sizes = useSelector(makeGetProductSizes());
    const selectedSku = useSelector(makeGetSelectedSku());
    const sizeCombinationNotExist = useSelector(makeGetSizeCombinationNotExist());
    const sizeRecommendationData = useSelector(makeGetSizeRecommendation());
    const oneSizeProduct = isOneSizeProduct(sizes, oneSizeProductCode);
    const isOneSizeProductInline = isOnlyOneSizeProduct(sizes);
    const notifyMeError = useSelector(makeGetNotifyMeError());
    const selectedColorId = useSelector(makeGetSelectedColorId());
    const revalidateErrors = () => {
        if (basketValidationState === BasketButtonError.SKU_OPEN_SIZE_SELECT || !sizeCombinationNotExist) {
            dispatch(basketActions.createErrorAction(undefined));
        }
        if (notifyMeError === NotifyMeError.SELECT_SIZE) {
            dispatch(productActions.setNotifyMeError(null));
        }
    };
    const selectSize = ({ sku, isSoldOut, isDisabled, }) => {
        dispatch(productActions.createSetSizeCombinationNotExistAction(Boolean(isDisabled)));
        dispatch(productActions.createSelectSizeAction({ sku, isSoldOut, isDisabled }));
        if (addToBasketOnSizeSelect) {
            setAddToBasketOnSizeSelect(false);
            if (!isSoldOut) {
                dispatch(selectedAdditionalProducts.length > 0
                    ? basketActions.createAddAdditionalProductsAction(selectedAdditionalProducts, quantity, ProductAddToBasketLocations.PDP)
                    : basketActions.createAddAction(quantity, ProductAddToBasketLocations.PDP, PDPVersion.V2));
            }
        }
        revalidateErrors();
    };
    useEffect(() => {
        dispatch(basketActions.createErrorAction(sizeCombinationNotExist ? BasketButtonError.SIZE_COMBINATION_NOT_EXIST : undefined));
        revalidateErrors();
        setAddToBasketOnSizeSelect(false);
    }, [sizeCombinationNotExist, selectedColorId]);
    useEffect(() => {
        if (basketValidationState === BasketButtonError.SKU_OPEN_SIZE_SELECT) {
            setAddToBasketOnSizeSelect(true);
        }
    }, [basketValidationState]);
    return (_jsx(_Fragment, { children: _jsx(SizeSelectButtons, { id: "product_detail_size_select", sizes: sizes, selectedSku: selectedSku, selectSize: selectSize, basketValidationState: basketValidationState, isOneSizeProduct: oneSizeProduct, isOneSizeProductInline: isOneSizeProductInline, sizeRecommendation: sizeRecommendationData.colorBased, notifyMeError: notifyMeError, selectedColorId: selectedColorId, sizeCombinationNotExist: sizeCombinationNotExist }) }));
};
export default SizeSelectContainerV2;
